import * as types from '../mutation-types';
import { Message } from 'element-gui';
const getDefaultState = () => {
  return {
    candidateStart:{},
    isRefreshAlternateFlag:false,   // 是否刷新替补中标候选人数据
  }
}
const state = getDefaultState()

const getters = {
  getCandidateStart: (state) => state.candidateStart,
  getIsRefreshAlternateFlag: (state) => state.isRefreshAlternateFlag,
};

const actions = {
  //更新替补抽取信息
  async setCandidateStart({ commit }, obj) {
    commit(types.GET_CANDIDATESTART, obj);
  },
  //更新是否刷新替补中标候选人数据
  async setIsRefreshAlternateFlag({ commit }, obj) {
    commit(types.GET_ISREFRESHALTERNATEFLAG, obj);
  },
};

const mutations = {
  [types.GET_CANDIDATESTART](state, obj) {
    state.candidateStart = obj;
  },
  [types.GET_ISREFRESHALTERNATEFLAG](state, obj) {
    state.isRefreshAlternateFlag = obj;
  },
  resetAlternateState (state) {
    Object.assign(state, getDefaultState())
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
